webpackJsonp([150810607242454],{

/***/ 382:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Официальный сайт Метшина Ильсура Раисовича, мэра г.Казани, представляет\nего не только как политика, но и как обычного человека, который, как и\nвсе, живёт в своём городе, смотрит ТВ и кино, читает книги и перемещается по\nгороду не только с мигалками и эскортом.</p>","frontmatter":{"title":"Официальный сайт мэра Казани","tabletImg":"","description":"Официальный сайт Метшина Ильсура Раисовича, мэра г.Казани","participation":["Дизайн и разработка","Эксплуатация и сопровождение"],"href":"https://metshin.ru/","statistics":["Первый среди мэров российских городов сайт с использованием современных JS-технологий"],"technologies":["html, css, sass","ruby, ruby-on-rails","javascript"],"longDesktopImg":"","desktopImg":"","path":"/metshin.ru/","files":null,"phoneImg":"","offerBtnHref":null,"offerBtnTitle":null,"offerDesc":null,"hideHref":null,"modulesTitle":null,"modules":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---metshin-ru-7eee8a2edf9ba0ed3c41.js